import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Camera, ArrowRight } from 'lucide-react';

interface Props {
  latitude: number;
  longitude: number;
  locationName: string;
}

export const NearbyWorkshopsBanner: React.FC<Props> = ({ latitude, longitude, locationName }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await supabase
          .rpc('workshops_near_location', {
            search_lat: latitude,
            search_lon: longitude,
            radius_miles: 100,
          });

        if (!data || data.length === 0) {
          setCount(0);
          return;
        }

        // Check for future dates
        const ids = data.map((r: { listing_id: string }) => r.listing_id);
        const now = new Date().toISOString().split('T')[0];
        const { data: listings } = await supabase
          .from('workshop_listings')
          .select('id, workshop_dates(end_date)')
          .in('id', ids)
          .eq('is_active', true);

        const withFuture = (listings || []).filter(l =>
          l.workshop_dates?.some((d: { end_date: string }) => d.end_date >= now)
        );

        setCount(withFuture.length);
      } catch {
        setCount(0);
      }
    };
    load();
  }, [latitude, longitude]);

  if (count === 0) return null;

  return (
    <Link
      to={`/workshops?q=${encodeURIComponent(locationName)}`}
      className="flex items-center gap-3 px-4 py-3 rounded-[4px] bg-[#0f1923] hover:bg-[#1a2b3d] transition-colors group"
    >
      <Camera className="w-5 h-5 text-[#c9922a] flex-shrink-0" />
      <span className="text-sm text-white">
        <strong>{count} workshop{count !== 1 ? 's' : ''}</strong> listed near {locationName}
      </span>
      <ArrowRight className="w-4 h-4 text-white/50 group-hover:text-white transition-colors ml-auto flex-shrink-0" />
    </Link>
  );
};
